import 'css-chunksrc/client/pages/capacityPage/table/styles.scss';export default {
  "tableWrapper": "_tableWrapper_1fs0w_1",
  "table": "_table_1fs0w_1",
  "resourceHeaderCell": "_resourceHeaderCell_1fs0w_12",
  "headerCell": "_headerCell_1fs0w_30",
  "monthCornerCell": "_monthCornerCell_1fs0w_48",
  "monthCell": "_monthCell_1fs0w_59",
  "withMonthRow": "_withMonthRow_1fs0w_77"
};